import * as types from './mutation-types'

export const toggleSidebar = ({commit}, config) => {
  if (config instanceof Object) {
    commit(types.TOGGLE_SIDEBAR, config)
  }
}

export const toggleDevice = ({commit}, device) => commit(types.TOGGLE_DEVICE, device)

export const expandMenu = ({commit}, menuItem) => {
  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false
    commit(types.EXPAND_MENU, menuItem)
  }
}

export const setUser = ({commit}, user) => {
  if (user) {
    commit(types.SET_USER, user)
    commit(types.FILTER_UNAUTHORIZED_ITEMS, user)
  }
}

export const setSubscription = ({commit}, subscription) => {
  commit(types.SET_SUBSCRIPTION, subscription)
}

export const setPlanPrices = ({commit}, planPrices) => {
  commit(types.SET_PLAN_PRICES, planPrices)
}

export const setProjectsCount = ({commit}, data) => {
  commit(types.SET_PROJECTS_COUNT, data)
}

export const switchEffect = ({commit}, effectItem) => {
  if (effectItem) {
    commit(types.SWITCH_EFFECT, effectItem)
  }
}
